function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _wrapNativeSuper(Class) { var _cache = typeof Map === "function" ? new Map() : undefined; _wrapNativeSuper = function _wrapNativeSuper(Class) { if (Class === null || !_isNativeFunction(Class)) return Class; if (typeof Class !== "function") { throw new TypeError("Super expression must either be null or a function"); } if (typeof _cache !== "undefined") { if (_cache.has(Class)) return _cache.get(Class); _cache.set(Class, Wrapper); } function Wrapper() { return _construct(Class, arguments, _getPrototypeOf(this).constructor); } Wrapper.prototype = Object.create(Class.prototype, { constructor: { value: Wrapper, enumerable: false, writable: true, configurable: true } }); return _setPrototypeOf(Wrapper, Class); }; return _wrapNativeSuper(Class); }

function _construct(Parent, args, Class) { if (_isNativeReflectConstruct()) { _construct = Reflect.construct; } else { _construct = function _construct(Parent, args, Class) { var a = [null]; a.push.apply(a, args); var Constructor = Function.bind.apply(Parent, a); var instance = new Constructor(); if (Class) _setPrototypeOf(instance, Class.prototype); return instance; }; } return _construct.apply(null, arguments); }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _isNativeFunction(fn) { return Function.toString.call(fn).indexOf("[native code]") !== -1; }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

// These values should NEVER change. The values are precisely for
// generating ULIDs.
var B32_CHARACTERS = "0123456789ABCDEFGHJKMNPQRSTVWXYZ";
var ENCODING = "0123456789ABCDEFGHJKMNPQRSTVWXYZ"; // Crockford's Base32

var ENCODING_LEN = 32; // from ENCODING.length;

var MAX_ULID = "7ZZZZZZZZZZZZZZZZZZZZZZZZZ";
var MIN_ULID = "00000000000000000000000000";
var RANDOM_LEN = 16;
var TIME_LEN = 10;
var TIME_MAX = 281474976710655; // from Math.pow(2, 48) - 1;

var ULID_REGEX = /^[0-7][0-9a-hjkmnp-tv-zA-HJKMNP-TV-Z]{25}$/;
var UUID_REGEX = /^[0-9a-fA-F]{8}-(?:[0-9a-fA-F]{4}-){3}[0-9a-fA-F]{12}$/;
var ULIDErrorCode;

(function (ULIDErrorCode) {
  ULIDErrorCode["Base32IncorrectEncoding"] = "B32_ENC_INVALID";
  ULIDErrorCode["DecodeTimeInvalidCharacter"] = "DEC_TIME_CHAR";
  ULIDErrorCode["DecodeTimeValueMalformed"] = "DEC_TIME_MALFORMED";
  ULIDErrorCode["EncodeTimeNegative"] = "ENC_TIME_NEG";
  ULIDErrorCode["EncodeTimeSizeExceeded"] = "ENC_TIME_SIZE_EXCEED";
  ULIDErrorCode["EncodeTimeValueMalformed"] = "ENC_TIME_MALFORMED";
  ULIDErrorCode["PRNGDetectFailure"] = "PRNG_DETECT";
  ULIDErrorCode["ULIDInvalid"] = "ULID_INVALID";
  ULIDErrorCode["Unexpected"] = "UNEXPECTED";
  ULIDErrorCode["UUIDInvalid"] = "UUID_INVALID";
})(ULIDErrorCode || (ULIDErrorCode = {}));

var ULIDError = /*#__PURE__*/function (_Error) {
  _inherits(ULIDError, _Error);

  var _super = _createSuper(ULIDError);

  function ULIDError(errorCode, message) {
    var _this;

    _classCallCheck(this, ULIDError);

    _this = _super.call(this, "".concat(message, " (").concat(errorCode, ")"));
    _this.name = "ULIDError";
    _this.code = errorCode;
    return _this;
  }

  return ULIDError;
}( /*#__PURE__*/_wrapNativeSuper(Error));

function randomChar(prng) {
  var rand = Math.floor(prng() * ENCODING_LEN);

  if (rand === ENCODING_LEN) {
    rand = ENCODING_LEN - 1;
  }

  return ENCODING.charAt(rand);
}

function replaceCharAt(str, index, char) {
  if (index > str.length - 1) {
    return str;
  }

  return str.substr(0, index) + char + str.substr(index + 1);
} // Code from https://github.com/devbanana/crockford-base32/blob/develop/src/index.ts


function crockfordEncode(input) {
  var output = [];
  var bitsRead = 0;
  var buffer = 0;
  var reversedInput = new Uint8Array(input.slice().reverse());

  var _iterator = _createForOfIteratorHelper(reversedInput),
      _step;

  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var byte = _step.value;
      buffer |= byte << bitsRead;
      bitsRead += 8;

      while (bitsRead >= 5) {
        output.unshift(buffer & 0x1f);
        buffer >>>= 5;
        bitsRead -= 5;
      }
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }

  if (bitsRead > 0) {
    output.unshift(buffer & 0x1f);
  }

  return output.map(function (byte) {
    return B32_CHARACTERS.charAt(byte);
  }).join("");
}

function crockfordDecode(input) {
  var sanitizedInput = input.toUpperCase().split("").reverse().join("");
  var output = [];
  var bitsRead = 0;
  var buffer = 0;

  var _iterator2 = _createForOfIteratorHelper(sanitizedInput),
      _step2;

  try {
    for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
      var character = _step2.value;
      var byte = B32_CHARACTERS.indexOf(character);

      if (byte === -1) {
        throw new Error("Invalid base 32 character found in string: ".concat(character));
      }

      buffer |= byte << bitsRead;
      bitsRead += 5;

      while (bitsRead >= 8) {
        output.unshift(buffer & 0xff);
        buffer >>>= 8;
        bitsRead -= 8;
      }
    }
  } catch (err) {
    _iterator2.e(err);
  } finally {
    _iterator2.f();
  }

  if (bitsRead >= 5 || buffer > 0) {
    output.unshift(buffer & 0xff);
  }

  return new Uint8Array(output);
}
/**
 * Fix a ULID's Base32 encoding -
 * i and l (case-insensitive) will be treated as 1 and o (case-insensitive) will be treated as 0.
 * hyphens are ignored during decoding.
 * @param id The ULID
 * @returns The cleaned up ULID
 */


function fixULIDBase32(id) {
  return id.replace(/i/gi, "1").replace(/l/gi, "1").replace(/o/gi, "0").replace(/-/g, "");
}

function incrementBase32(str) {
  var done = undefined,
      index = str.length,
      char,
      charIndex,
      output = str;
  var maxCharIndex = ENCODING_LEN - 1;

  while (!done && index-- >= 0) {
    char = output[index];
    charIndex = ENCODING.indexOf(char);

    if (charIndex === -1) {
      throw new ULIDError(ULIDErrorCode.Base32IncorrectEncoding, "Incorrectly encoded string");
    }

    if (charIndex === maxCharIndex) {
      output = replaceCharAt(output, index, ENCODING[0]);
      continue;
    }

    done = replaceCharAt(output, index, ENCODING[charIndex + 1]);
  }

  if (typeof done === "string") {
    return done;
  }

  throw new ULIDError(ULIDErrorCode.Base32IncorrectEncoding, "Failed incrementing string");
}
/**
 * Decode time from a ULID
 * @param id The ULID
 * @returns The decoded timestamp
 */


function decodeTime(id) {
  if (id.length !== TIME_LEN + RANDOM_LEN) {
    throw new ULIDError(ULIDErrorCode.DecodeTimeValueMalformed, "Malformed ULID");
  }

  var time = id.substr(0, TIME_LEN).toUpperCase().split("").reverse().reduce(function (carry, char, index) {
    var encodingIndex = ENCODING.indexOf(char);

    if (encodingIndex === -1) {
      throw new ULIDError(ULIDErrorCode.DecodeTimeInvalidCharacter, "Time decode error: Invalid character: ".concat(char));
    }

    return carry += encodingIndex * Math.pow(ENCODING_LEN, index);
  }, 0);

  if (time > TIME_MAX) {
    throw new ULIDError(ULIDErrorCode.DecodeTimeValueMalformed, "Malformed ULID: timestamp too large: ".concat(time));
  }

  return time;
}
/**
 * Detect the best PRNG (pseudo-random number generator)
 * @param root The root to check from (global/window)
 * @returns The PRNG function
 */


function detectPRNG(root) {
  var rootLookup = detectRoot();
  var globalCrypto = rootLookup && (rootLookup.crypto || rootLookup.msCrypto) || null;

  if (typeof (globalCrypto === null || globalCrypto === void 0 ? void 0 : globalCrypto.getRandomValues) === "function") {
    return function () {
      var buffer = new Uint8Array(1);
      globalCrypto.getRandomValues(buffer);
      return buffer[0] / 0xff;
    };
  } else if (typeof (globalCrypto === null || globalCrypto === void 0 ? void 0 : globalCrypto.randomBytes) === "function") {
    return function () {
      return globalCrypto.randomBytes(1).readUInt8() / 0xff;
    };
  } else ;

  throw new ULIDError(ULIDErrorCode.PRNGDetectFailure, "Failed to find a reliable PRNG");
}

function detectRoot() {
  if (inWebWorker()) return self;

  if (typeof window !== "undefined") {
    return window;
  }

  if (typeof global !== "undefined") {
    return global;
  }

  if (typeof globalThis !== "undefined") {
    return globalThis;
  }

  return null;
}

function encodeRandom(len, prng) {
  var str = "";

  for (; len > 0; len--) {
    str = randomChar(prng) + str;
  }

  return str;
}
/**
 * Encode the time portion of a ULID
 * @param now The current timestamp
 * @param len Length to generate
 * @returns The encoded time
 */


function encodeTime(now) {
  var len = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : TIME_LEN;

  if (isNaN(now)) {
    throw new ULIDError(ULIDErrorCode.EncodeTimeValueMalformed, "Time must be a number: ".concat(now));
  } else if (now > TIME_MAX) {
    throw new ULIDError(ULIDErrorCode.EncodeTimeSizeExceeded, "Cannot encode a time larger than ".concat(TIME_MAX, ": ").concat(now));
  } else if (now < 0) {
    throw new ULIDError(ULIDErrorCode.EncodeTimeNegative, "Time must be positive: ".concat(now));
  } else if (Number.isInteger(now) === false) {
    throw new ULIDError(ULIDErrorCode.EncodeTimeValueMalformed, "Time must be an integer: ".concat(now));
  }

  var mod,
      str = "";

  for (var currentLen = len; currentLen > 0; currentLen--) {
    mod = now % ENCODING_LEN;
    str = ENCODING.charAt(mod) + str;
    now = (now - mod) / ENCODING_LEN;
  }

  return str;
}

function inWebWorker() {
  // @ts-ignore
  return typeof WorkerGlobalScope !== "undefined" && self instanceof WorkerGlobalScope;
}
/**
 * Check if a ULID is valid
 * @param id The ULID to test
 * @returns True if valid, false otherwise
 * @example
 *   isValid("01HNZX8JGFACFA36RBXDHEQN6E"); // true
 *   isValid(""); // false
 */


function isValid(id) {
  return typeof id === "string" && id.length === TIME_LEN + RANDOM_LEN && id.toUpperCase().split("").every(function (char) {
    return ENCODING.indexOf(char) !== -1;
  });
}
/**
 * Create a ULID factory to generate monotonically-increasing
 *  ULIDs
 * @param prng The PRNG to use
 * @returns A ulid factory
 * @example
 *  const ulid = monotonicFactory();
 *  ulid(); // "01HNZXD07M5CEN5XA66EMZSRZW"
 */


function monotonicFactory(prng) {
  var currentPRNG = prng || detectPRNG();
  var lastTime = 0,
      lastRandom;
  return function _ulid(seedTime) {
    var seed = !seedTime || isNaN(seedTime) ? Date.now() : seedTime;

    if (seed <= lastTime) {
      var incrementedRandom = lastRandom = incrementBase32(lastRandom);
      return encodeTime(lastTime, TIME_LEN) + incrementedRandom;
    }

    lastTime = seed;
    var newRandom = lastRandom = encodeRandom(RANDOM_LEN, currentPRNG);
    return encodeTime(seed, TIME_LEN) + newRandom;
  };
}
/**
 * Generate a ULID
 * @param seedTime Optional time seed
 * @param prng Optional PRNG function
 * @returns A ULID string
 * @example
 *  ulid(); // "01HNZXD07M5CEN5XA66EMZSRZW"
 */


function ulid(seedTime, prng) {
  var currentPRNG = prng || detectPRNG();
  var seed = !seedTime || isNaN(seedTime) ? Date.now() : seedTime;
  return encodeTime(seed, TIME_LEN) + encodeRandom(RANDOM_LEN, currentPRNG);
}
/**
 * Convert a ULID to a UUID
 * @param ulid The ULID to convert
 * @returns A UUID string
 */


function ulidToUUID(ulid) {
  var isValid = ULID_REGEX.test(ulid);

  if (!isValid) {
    throw new ULIDError(ULIDErrorCode.ULIDInvalid, "Invalid ULID: ".concat(ulid));
  }

  var uint8Array = crockfordDecode(ulid);
  var uuid = Array.from(uint8Array).map(function (byte) {
    return byte.toString(16).padStart(2, "0");
  }).join("");
  uuid = uuid.substring(0, 8) + "-" + uuid.substring(8, 12) + "-" + uuid.substring(12, 16) + "-" + uuid.substring(16, 20) + "-" + uuid.substring(20);
  return uuid.toUpperCase();
}
/**
 * Convert a UUID to a ULID
 * @param uuid The UUID to convert
 * @returns A ULID string
 */


function uuidToULID(uuid) {
  var isValid = UUID_REGEX.test(uuid);

  if (!isValid) {
    throw new ULIDError(ULIDErrorCode.UUIDInvalid, "Invalid UUID: ".concat(uuid));
  }

  var bytes = uuid.replace(/-/g, "").match(/.{1,2}/g);

  if (!bytes) {
    throw new ULIDError(ULIDErrorCode.Unexpected, "Failed parsing UUID bytes: ".concat(uuid));
  }

  var uint8Array = new Uint8Array(bytes.map(function (byte) {
    return parseInt(byte, 16);
  }));
  return crockfordEncode(uint8Array);
}

export { MAX_ULID, MIN_ULID, TIME_LEN, TIME_MAX, ULIDError, ULIDErrorCode, decodeTime, encodeTime, fixULIDBase32, incrementBase32, isValid, monotonicFactory, ulid, ulidToUUID, uuidToULID };